import { DeleteSquare } from '../Icon/icon'
import style from './DeletableChip.module.scss'

interface DeletableChipProp {
  onDelete: (keyword: string) => void
  onClick: (keyword: string) => void
  label: string
  chipKey: string
  chipId: string
}

const DeletableChip = ({ chipId, chipKey, label, onDelete, onClick }: DeletableChipProp) => {
  return (
    <div>
      <div className={style.chip} key={chipKey} id={chipId}>
        <a
          href="/#"
          onClick={(e) => {
            e.preventDefault()
            onClick(chipKey === null ? '' : chipKey)
          }}
          onKeyDown={() => {
            onClick(chipKey === null ? '' : chipKey)
          }}
        >
          <span className={style['chip-value']}>{label}</span>
        </a>
        <button
          type="button"
          className={style['chip-delete-button']}
          onClick={() => {
            onDelete(chipKey === null ? '' : chipKey)
          }}
        >
          <DeleteSquare />
        </button>
      </div>
    </div>
  )
}

export default DeletableChip
